import React from 'react';

import { reconcileValue } from '@neptune/shared/common-util';
import { EntitiesLists, getRunIdentificationPair } from '@neptune/shared/entity-domain';

type ExperimentNamesToRunId = Map<string, string>;
type ExperimentNamesToRunIdByProject = Map<string, ExperimentNamesToRunId>;

const EMPTY_MAP = new Map<any, never>();

export function useExperimentIdentificationMapSingleProject(
  projectIdentifier: string,
  data: Map<string, EntitiesLists>,
): ExperimentNamesToRunId {
  const namesToShortIdsByProject = useExperimentIdentificationMap(data);

  return namesToShortIdsByProject.get(projectIdentifier) ?? EMPTY_MAP;
}

export function useExperimentIdentificationMap(
  data: Map<string, EntitiesLists>,
): ExperimentNamesToRunIdByProject {
  const [namesToShortIdsByProject, setNamesToShortIdsByProject] =
    React.useState<ExperimentNamesToRunIdByProject>(EMPTY_MAP);

  React.useEffect(() => {
    if (!data) {
      return;
    }

    const namesToRunIds = new Map<string, ExperimentNamesToRunId>();

    for (const [projectIdentifier, entries] of data) {
      for (const entry of entries.experiments) {
        const runIdentification = getRunIdentificationPair(entry);

        if (!runIdentification) {
          continue;
        }

        if (runIdentification.experimentName && runIdentification.runId) {
          let projectMap = namesToRunIds.get(projectIdentifier);

          if (!projectMap) {
            projectMap = new Map();
            namesToRunIds.set(projectIdentifier, projectMap);
          }

          projectMap.set(runIdentification.experimentName, runIdentification.runId);
        }
      }
    }

    setNamesToShortIdsByProject((prev) => reconcileValue(namesToRunIds, prev));
  }, [data]);

  return namesToShortIdsByProject;
}
